/* eslint no-unused-vars:0 */

import axios from "axios";

export const company = {
    namespaced: true,
    state: {
        company: {},
        logoUrl: null,
    },
    actions: {
        loadCompany ({ commit, getters, rootGetters }) {
            return axios
                .get('/api/companies/' + rootGetters['auth/user'].company_id)
                .then(response => {
                    commit('setCompany', response.data.data.company);
                    commit('setLogoUrl', response.data.data.additionalData.fileUrls.logo.original);
                    return response;
                })
        },
    },
    mutations: {
        setCompany (state, company) {
            state.company = company;
        },

        setLogoUrl (state, logoUrl) {
            state.logoUrl = logoUrl;
        },
    },
    getters: {
        company: state => state.company,
        logoUrl: state => state.logoUrl,
        isMainCompany: state => state.company.is_main_company
    }
};
